<!--
@Author: Yu Xiujie
@Desc: 移动端表单
@Date: 2022-07-18
-->

<template>
  <!-- 不是弹窗的表单 -->
  <div class="pop-box" id="information">
    <!-- 插槽 -->
    <slot></slot>
    <!-- 表单开始 -->
    <van-form @submit="xhrOnSubmit">
      <van-field
        v-model="paramQuery.name"
        left-icon="../../static/mobile/icon_input_user.png"
        placeholder="请输入您的姓名"
        :rules="[{ required: true, message: '请输入您的姓名' }]"
      />
      <van-field
        v-model="paramQuery.phone"
        left-icon="../../static/mobile/icon_input_phone.png"
        placeholder="请输入您的电话号码"
        :rules="[{ required: true, message: '请输入您的电话号码' }]"
      />
      <van-field
        v-model="paramQuery.companyName"
        left-icon="../../static/mobile/icon_input_comply.png"
        placeholder="请输入公司全称"
        :rules="[{ required: true, message: '请输入公司全称' }]"
      />

      <van-field
        name=""
        label=""
        v-model="paramQuery.provinceCity"
        readonly
        left-icon="../../static/mobile/icon_input_position.png"
        placeholder="请选择公司所在城市"
        :rules="[{ required: true, message: '请输入公司所在城市' }]"
        clickable
        @click="showAreaEvent"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          title="省-市"
          @confirm="onConfirm"
          @change="onChangeDetail"
          :columns-num="2"
          @cancel="showArea = false"
          value="110101"
        />
      </van-popup>

      <van-button round block type="info" native-type="submit" class="popup-btn"
        >立即预约</van-button
      >
    </van-form>
  </div>
</template>

<script type="text/javascript">
import { postMakeAppoint, postFindProvinceOrCity } from "../service/apis";
import { HTTP_CODE } from "../service/axios_constants";
import { checkNull } from "../filters/filters";
import { Toast } from "vant";

export default {
  name: "mFromPage",
  props: {
    //页面来源
    source: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      paramQuery: {
        name: "",
        phone: "",
        companyName: "",
        source: "",
        bdVid: "",
        province: "",
        city: "",
        provinceCity: ""
      },

      showArea: false,
      areaList: {
        province_list: {
          110000: "北京市",
          120000: "天津市"
        },
        city_list: {
          110100: "北京市",
          120100: "天津市"
        }
      },

      searchResult: []
    };
  },

  components: {},

  mounted() {},

  created() {
    // this.paramQuery.bdVid = this.$route.query.bd_vid;
    // console.log(this.$route.query.bd_vid);
    if (!checkNull(this.$route.query.bd_vid)) {
      if (this.$route.query.bd_vid.length > 1) {
        this.paramQuery.bdVid = this.$route.query.bd_vid[1];
      } else {
        this.paramQuery.bdVid = this.$route.query.bd_vid;
      }
    }

    this.paramQuery.source = this.source;
    this.xhrPostFindProvinceOrCity();
  },

  methods: {
    // xhr -- 提交
    xhrOnSubmit() {
      postMakeAppoint(this.paramQuery).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          Toast("预约成功!");
          //预约成功以后清空数据
          this.paramQuery.name = "";
          this.paramQuery.phone = "";
          this.paramQuery.companyName = "";
          this.paramQuery.provinceCity = "";
        }
      });
    },

    showAreaEvent() {
      console.log("dianji");
      this.showArea = true;
    },

    onChangeDetail(picker) {
      let val = picker.getValues();

      this.xhrPostFindProvinceOrCity(val[0].code);
    },

    onConfirm(values) {
      this.paramQuery.province = values[0].name;
      if (checkNull(values[1])) {
        this.paramQuery.provinceCity = values[0].name;
        this.paramQuery.city = values[0].name;
      } else {
        this.paramQuery.provinceCity = values[0].name + "/" + values[1].name;
        this.paramQuery.city = values[1].name;
      }
      this.showArea = false;
    },

    // xhr----查询省市接口
    xhrPostFindProvinceOrCity(value) {
      let paramQuery = {
        provinceId: value
      };
      postFindProvinceOrCity(paramQuery).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          let areaArr = res.data;
          let obj = {};
          areaArr.forEach(item => {
            obj[item.code] = item.name;
          });
          if (checkNull(paramQuery.provinceId)) {
            this.areaList.province_list = obj;
          } else {
            this.areaList.city_list = obj;
          }
        }
      });
    }
  }
};
</script>

<style>
#information .van-cell {
  margin: 0 auto;
  margin-bottom: 20px;
  width: 610px;
  height: 90px;
  background: #ffffff;
  border-radius: 17px;
  border: 1px solid #f4f4f4;
}
#information .van-field__left-icon {
  width: 84px;
  height: 90px;
}
#information .van-field__left-icon .van-icon {
  margin: 0 auto;
  width: 32px;
  display: flex;
  align-items: center;
}
#information .van-field__left-icon .van-icon__image {
  width: 32px;
  height: 32px;
  margin-top: 21px;
}
#information .van-cell .van-field__value {
  width: 414px;
  overflow: hidden;
}
#information .van-cell .van-field__value .van-field__control {
  margin-top: 20px;
}
#information .van-cell .van-field__value .van-field__body {
  font-size: 28px;
}
#information .van-cell .van-field__value .van-field__error-message {
  display: none;
}

#information .van-picker__toolbar {
  width: 100%;
  height: 80px;
  background: #f4f4f4;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 80px;
  padding: 0 25px;
}

#information .van-picker__cancel {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 80px;
}
#information .van-picker__title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 80px;
}
#information .van-picker__confirm {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 80px;
}

#information .van-picker-column__item {
  /* display: block; */
  /* height: 78px !important; */
  /* line-height: 78px !important; */
  font-size: 32px;
  /* color: #999; */
}
/*#information .van-cell:not(:last-child)::after {
  border: 0px;
}
#information .van-picker__columns {
  height: 440px !important;
}

#information .van-picker-column__item--selected{
  font-size: 36px;
  color: #333;
  font-weight: 600;
}
#information .van-.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  display: none;
} */
</style>

<style lang="scss" scoped>
.pop-box {
  width: 690px;
  height: 762px;
  background: #ffffff;
  margin: 41px auto 0;
  box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 70px 40px 50px;
  border-radius: 16px;
  background: #ffffff;
  margin-bottom: 48px;
  .pop-box-title {
    font-size: 34px;
    font-weight: 600;
    color: #100f0f;
    margin-bottom: 57px;
    display: block;
  }

  //立即预约
  .popup-btn {
    width: 288px;
    height: 80px;
    background: #1985ff;
    border-radius: 40px;
    color: #ffffff;
    font-size: 30px;
    line-height: 80px;
    margin: 0 auto;
    margin-top: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mFromPage.vue